import { Component, OnInit } from '@angular/core';
import { AuthGuard } from 'src/shared/authguard/auth-guard.guard';
import { AuditMapComponent } from "../audit-map/audit-map.component";
import { MapComponent } from "./pages/map.component";
@Component({
  selector: 'app-map-wrapper',
  template: `
 @if (hasAuditPermission) {
  <app-audit-map></app-audit-map>
} @else {
  <app-map></app-map>
}
  `,
  imports: [AuditMapComponent, MapComponent]
})
export class MapWrapperComponent implements OnInit {
  hasAuditPermission = false;

  constructor() { }

  ngOnInit(): void {
    this.hasAuditPermission = sessionStorage.getItem('auditMap') === 'true';
  }
}